export const QUERY_FIRST_NOTIFICATIONS_COUNT = 15;
export const EVALUATION_QUESTIONNAIRE_CONTENT = 'You can now complete the evaluation questionnaire';
 